import React from "react";
import { Box, Container, Typography, Button, useTheme } from "@mui/material";
import { Explore } from "@mui/icons-material";

interface MallHubEmptyStateProps {
  onNavigateToExplore: () => void;
}

/**
 * MallHubEmptyState Component
 *
 * Displayed when no mall is selected. Prompts user to navigate to Explore page.
 */
const MallHubEmptyState: React.FC<MallHubEmptyStateProps> = ({
  onNavigateToExplore,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(135deg, ${theme.palette.primary.main}15 0%, ${theme.palette.secondary.main}15 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pt: 8,
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: "center", py: 8 }}>
          <Box
            sx={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              bgcolor: theme.palette.primary.main + "20",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 3,
            }}
          >
            <Explore sx={{ fontSize: 60, color: "primary.main" }} />
          </Box>

          <Typography
            variant="h4"
            gutterBottom
            fontWeight="bold"
            color="text.primary"
          >
            Select a Mall to Get Started
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, fontSize: "1.1rem" }}
          >
            Discover amazing offers, events, and stores at your favorite
            shopping destinations
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={onNavigateToExplore}
            startIcon={<Explore />}
            sx={{
              px: 4,
              py: 1.5,
              fontSize: "1rem",
              fontWeight: 600,
              borderRadius: 3,
              textTransform: "none",
              boxShadow: 3,
              "&:hover": {
                boxShadow: 6,
                transform: "translateY(-2px)",
              },
              transition: "all 0.2s ease-in-out",
            }}
          >
            Browse Malls
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default MallHubEmptyState;
